export const CSRF_DISABLE = false;

export const CONTEXT_WEBSITE = 'website';
export const CONTEXT_MOBILE_APP = 'mobile-app';

const appParameters = {
  APP_CONTEXT: CONTEXT_WEBSITE,
  CONSOLE_LOG_ENABLE: (typeof GLOBAL != 'undefined' ? GLOBAL.CONSOLE_LOG_ENABLE : true),
  APP_CMS_COOKIES: (typeof GLOBAL != 'undefined' ? GLOBAL.APP_CMS_COOKIES : false),

  API_BASE: `${process.env.API_BASE}`,
  API_CLIENT_ID: '1_43fygqikqbk0k0w4404g0ok8ksk0w8swowg8okoks40osg0okw',
  // According to this part of RFC8252 https://datatracker.ietf.org/doc/html/rfc8252#section-8.5
  // We do not use an embeded client secret, and our authorization backend does not enforce the usage of it
  // So we have a mechanism on the backend to assign a user to the returned access_token after successful user
  // oauth login
  API_CLIENT_SECRET: '',

  GMAPS_API_KEY: `${process.env.GMAPS_API_KEY}`,
  MAPBOX_API_KEY: `${process.env.MAPBOX_API_KEY}`,
  OPENCAGE_API_KEY: `${process.env.OPENCAGE_API_KEY}`,

  // use wroclaw as absolute fallback in case no current location can be fetched whatsoever
  fallbackCoordinates: {
    longitude: 17.038538,
    latitude: 51.107883,
  },

  // default moment js config
  moment: {
    dateFormat: 'DD.MM.YYYY',
    dateFormatWithoutDay: 'DD.MM',
    datetimeFormat: 'DD.MM.YYYY HH:mm',
    dayMonthFormat: 'DD MMM',
    dayMonthYearFormat: 'DD MMM YYYY',
    hourMinuteFormat: 'HH:mm',
  },

  // default datetime picker config
  picker: {
    dateFormat: 'dd.mm.yyyy',
    datetimeFormat: 'dd.mm.yyyy hh:ii',
  },

  decimalPoint: ',',

  isRTL: false,

  mercureHub: `${process.env.MERCURE_PUBLIC_URL || process.env.MERCURE_PUBLISH_URL}`,

  APP_SECTION_ACCOMMODATION: 'accommodation',
  APP_SECTION_FOOD: 'food',
  APP_SECTION_HANDICRAFT_AND_SERVICES: 'handicraftandservices',
  APP_SECTION_PRESS: 'press',
};

export default appParameters;
